import AddPatient from './AddPatient';

export default AddPatient;
